import { useEffect } from 'react'
import { useMantineColorScheme } from '@mantine/core'

export const useWindowExports = () => {
  const { colorScheme, setColorScheme } = useMantineColorScheme()

  useEffect(() => {
    // Expose color scheme functions to window
    window.reactFunctions = {
      ...window.reactFunctions,
      switchTheme: (theme: 'light' | 'dark') => {
        setColorScheme(theme)
      },
      getColorScheme: () => colorScheme,
      setColorScheme: (scheme: 'light' | 'dark' | 'auto') => {
        setColorScheme(scheme)
      },
    }

    // Cleanup (optional, but good practice)
    return () => {
      // You might want to keep the functions, so cleanup is optional
    }
  }, [colorScheme, setColorScheme])
}
